import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetPanel,
  SheetTitle,
} from "@volca/ui/components/ui/sheet";
import { Stack } from "@volca/ui/components/ui/stack";
import { CalendarLine } from "@/profitability/calendar/calendar-line";
import { RunList } from "@/profitability/run-list";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";

/**
 * Every period the template has run, with its reruns, and the calendar that
 * sets them, in a sheet over the page: opened from the foot of the period
 * picker. A period opens on the page behind it.
 */
export const PeriodHistorySheet = ({
  open,
  onOpenChange,
  businessId,
  reportId,
  onOpenRun,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  businessId: string;
  reportId: string;
  onOpenRun: (runId: string, period: EnrichedProfitabilityPeriod) => void;
}) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent variant="inset" className="max-w-4xl">
      <SheetHeader className="gap-1 pr-14">
        <SheetTitle className="text-lg">All periods and reruns</SheetTitle>
        <SheetDescription>
          A period&apos;s result is its newest run. Its earlier runs open from
          when it ran, under the period&apos;s name.
        </SheetDescription>
      </SheetHeader>
      <SheetPanel className="pt-0">
        <Stack gap={4} align="stretch">
          <CalendarLine businessId={businessId} reportId={reportId} />
          {open && (
            <RunList
              businessId={businessId}
              reportId={reportId}
              onOpenRun={onOpenRun}
            />
          )}
        </Stack>
      </SheetPanel>
    </SheetContent>
  </Sheet>
);
